// utils/getToken.js
export function getAuthToken() {
    const currentUser = sessionStorage.getItem("currentUser");
    return sessionStorage.getItem(`token_${currentUser}`);
  }
  